// Collaborator-free reads of the passkey registration JSON, and the paths the
// start, finish, and decline fetches use.
// A falsy alert returns the same options object. A truthy alert returns that
// same alert reference. Unknown keys stay on the object they arrived on.
// Nothing here calls fetch, mounts a view, or touches the DOM.

export const registerStartApi = process.env.VUE_APP_PASSKEY_REGISTER_START_API
export const registerFinishApi = process.env.VUE_APP_PASSKEY_REGISTER_FINISH_API
export const declinePasskeyApi = process.env.VUE_APP_PASSKEY_DECLINE_API

// Same options object when alert is absent: one alert read, then that body.
// Same alert reference when present: the branch read, then the value read.
// Callers branch on registrationStartTookAlert and do not read alert again.
// A null or undefined body throws on the property read, the same as the inline access.
let startTookAlert = false

export function readRegistrationStart(body) {
	let tookAlert = false
	try {
		if (body.alert) {
			const alert = body.alert
			tookAlert = true
			return alert
		}
		return body
	} finally {
		startTookAlert = tookAlert
	}
}

export function registrationStartTookAlert() {
	return startTookAlert
}

// Same alert reference. A missing alert stays undefined. reason is ignored.
// A null or undefined body throws on the property read.
export function readRegistrationFinish(body) {
	return body.alert
}
